const TOKEN_KEY = 'dispatch_token'
const REFRESH_TOKEN_KEY = 'dispatch_refresh_token'
const USER_KEY = 'dispatch_user'
const USER_INFO_KEY = 'dispatch_user_info'
const EXPIRES_TIME_KEY = 'dispatch_expires_time'
const APP_ROLE_KEY = 'dispatch_app_role'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setRefreshToken(token) {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token)
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  }
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function getUserInfo() {
  const raw = localStorage.getItem(USER_INFO_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setUser(user) {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

function setRawUserInfo(userInfo) {
  if (userInfo) {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
  } else {
    localStorage.removeItem(USER_INFO_KEY)
  }
}

function mapDisplayUser(userInfo) {
  if (!userInfo) {
    return null
  }
  return {
    id: userInfo.id,
    name: userInfo.nickname || userInfo.mobile || '调度员',
    account: userInfo.mobile || '',
    mobile: userInfo.mobile || '',
    avatar: userInfo.avatar || '',
    appRole: userInfo.appRole,
    role: 'dispatcher'
  }
}

/** 保存登录 token 与用户信息（对齐小程序 saveLoginSession） */
export function saveLoginSession(loginData, userInfo) {
  if (loginData) {
    setToken(loginData.accessToken || '')
    setRefreshToken(loginData.refreshToken || '')
    if (loginData.expiresTime) {
      localStorage.setItem(EXPIRES_TIME_KEY, String(loginData.expiresTime))
    }
    if (loginData.appRole != null) {
      localStorage.setItem(APP_ROLE_KEY, String(loginData.appRole))
    }
  }
  if (userInfo) {
    setRawUserInfo(userInfo)
    setUser(mapDisplayUser(userInfo))
  }
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function removeUser() {
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}

export function isLoggedIn() {
  return !!getToken()
}

export function clearLoginSession() {
  removeToken()
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(EXPIRES_TIME_KEY)
  localStorage.removeItem(APP_ROLE_KEY)
  removeUser()
}

export function logout() {
  clearLoginSession()
}
